import { createContext, useContext, useState, useEffect } from "react";
import { t } from "./translations";

const AppContext = createContext({});

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("app_lang") || "ar";
    document.documentElement.dir = saved === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = saved;
    return saved;
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("app_theme") || "light");

  useEffect(() => {
    localStorage.setItem("app_lang", lang);
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("app_theme", theme);
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const toggleLang = () => setLang(l => l === "ar" ? "en" : "ar");
  const toggleTheme = () => setTheme(t => t === "light" ? "dark" : "light");

  return (
    <AppContext.Provider value={{ lang, theme, toggleLang, toggleTheme }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);

// Reactive translation hook — re-renders when lang changes
export function useT() {
  const { lang } = useApp();
  return t[lang] || t["ar"];
}